import { t } from "@/i18n";
import styles from "./ReconnectWindow.module.css";

export const ReconnectWindowLayout = () => {
    return (
        <div className={styles.reconnectWindow}>
            <div className={styles.reconnectWindowInfo}>{t("reconnect.status")}</div>
        </div>
    );
};
